module.exports = __webpack_public_path__ + "img/creico.8a4c210c.png";